const deepDiveSeries = [
  { slug: "hard-truths", name: "Hard Truths" },
  { slug: null, name: "None" },
];

export const getDeepDiveSeriesListAsyncForTypeahead = () => () => {
  return Promise.resolve({
    options: deepDiveSeries,
  });
};
